import React from 'react';
import { Link } from 'react-router';

import { withRipple } from '@getgrover/ui';

import Button from '../Button';
import {
    Circle,
    CircleBackground,
    Content,
    Title,
    Delimiter,
    Description,
    ArrowRightIcon,
    RippleContainer,
} from './Action.styles';

const RippleEffect = withRipple(RippleContainer);

const Action = ({
    href,
    target,
    color,
    className,
    onClick,
    title,
    description,
    withDelimiter,
    icon,
    disabled,
    spaLink,
}) => {
    return (
        <>
            {spaLink ? (
                <Link to={href}>
                    <Content hasDescription={Boolean(description)}>
                        <Circle>
                            <CircleBackground color={color} />
                            {icon}
                        </Circle>
                        <Title>{title}</Title>
                        {description && <Description>{description}</Description>}
                        <ArrowRightIcon />

                        {withDelimiter && <Delimiter />}
                        {!disabled && <RippleEffect />}
                    </Content>
                </Link>
            ) : (
                <Button
                    className={className}
                    href={href}
                    onClick={onClick}
                    disabled={disabled}
                    target={target}
                >
                    <Content transparent={disabled} hasDescription={Boolean(description)}>
                        <Circle>
                            <CircleBackground color={color} />
                            {icon}
                        </Circle>
                        <Title>{title}</Title>
                        {description && <Description>{description}</Description>}
                        <ArrowRightIcon />

                        {withDelimiter && <Delimiter />}
                        {!disabled && <RippleEffect />}
                    </Content>
                </Button>
            )}
        </>
    );
};

Action.defaultProps = {
    href: undefined,
    target: undefined,
    onClick: undefined,
    className: '',
    overrides: {},
    disabled: false,
    withDelimiter: false,
    spaLink: false,
    description: '',
};

export default Action;
